import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as fonts from 'view/styles/fonts';
import { colors } from '@atlaskit/theme';

const barWidths = ['20%', '40%', '60%', '80%', '100%'];
const barColours = [
    token('color.chart.danger.bold', colors.R500),
    token('color.chart.danger', colors.R300),
    token('color.chart.warning', colors.Y300),
    token('color.chart.success', colors.G300),
    token('color.chart.success.bold', colors.G400),
];

interface BarProps {
    score: number | null;
}

export const Bar = styled.div<BarProps>`
    background: ${token('color.chart.neutral', colors.N40)};
    height: ${grid.multiple(0.25).px};
    margin-top: ${grid.multiple(0.625).px};
    position: relative;

    &::before {
        /* stylelint-disable scale-unlimited/declaration-strict-value */
        background-color: ${(props) =>
            props.score === null ? token('color.chart.neutral', colors.N40) : barColours[props.score]};
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        top: 0;
        transition: all 0.2s ease-out;
        width: ${(props) => (props.score === null ? 0 : barWidths[props.score])};
    }
`;

export const Dividers = styled.span`
    border-left: 5px solid ${token('color.border.inverse', colors.N0)};
    border-right: 5px solid ${token('color.border.inverse', colors.N0)};
    bottom: 0;
    left: 19%;
    position: absolute;
    right: 19%;
    top: 0;

    &::after {
        border-left: 5px solid ${token('color.border.inverse', colors.N0)};
        border-right: 5px solid ${token('color.border.inverse', colors.N0)};
        bottom: 0;
        content: '';
        left: 30%;
        position: absolute;
        right: 30%;
        top: 0;
    }
`;

export const Hint = styled.p`
    color: ${token('color.text.subtlest', colors.N90)};
    ${fonts.small}
    height: ${grid.multiple(2).px};
    line-height: ${grid.multiple(2).px};
    margin-top: ${token('space.050', '4px')};
    position: relative;
    text-align: center;
`;
